<template>
 
   <BContainer class="container-pages" >
    <BRow>
      <BCol xl="3">
        <div class="shadow rounded p-element-page bg-white mb-2">          
            <FilterCategoryEvent :categories="categories.data"></FilterCategoryEvent>
        </div>
      </BCol>
      <BCol xl="6">
         <EventSearch />
         <NuxtPage></NuxtPage>
      </BCol>
      <BCol xl="3">
      <div class="container-a mt-2 mb-3"  v-if="$screen.showDesktopAds">
            <AdsEventTopRight></AdsEventTopRight>
      </div>
      <TopPriceBlock :xl="12" :lg="12" :counter="3"></TopPriceBlock>
      </BCol>
    </BRow>
    </BContainer>
</template>

<script setup>
import EventSearch from '~/components/search/EventSearch.vue'
 const route = useRoute();
import { useEventCategoryStore } from "~/stores/events/category";
import { BContainer, BRow, BCol } from 'bootstrap-vue-next';
import TopPriceBlock from '~/components/widgets/Stips/TopPriceBlock.vue';
import FilterCategoryEvent from '~/components/cms/event/Filter/FilterCategoryEvent.vue';
import AdsEventTopRight from '~/components/GoogleAdvertisements/AdsEventTopRight.vue';

const config = useRuntimeConfig()
const useStore = useEventCategoryStore();


const { data: categories  , error } =  await useAsyncData(
   () => `events-categories-${route.fullPath}`,
  async () => useStore.getEventCategoryCache(),
  {
    watch: [
      () => route.fullPath
    ],
  });

</script>

<style>

</style>
